import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-radio-off",
  "use": "icon-radio-off-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-radio-off\">\n<style type=\"text/css\">\n\t#icon-radio-off .st0{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\n</style>\n<path class=\"st0\" d=\"M512,938.7c235.6,0,426.7-191,426.7-426.7S747.6,85.3,512,85.3S85.3,276.4,85.3,512S276.4,938.7,512,938.7z\n\t M512,1024C229.2,1024,0,794.8,0,512S229.2,0,512,0s512,229.2,512,512S794.8,1024,512,1024z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/radio-off.svg
// module id = +w1A
// module chunks = 28